(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cross-variant-picker"] && !Shopify.designMode) return;
  try {
    (function () {
  function initCVP(root) {
    var container = root.querySelector('[data-cvp-options]');
    if (!container) return;

    var buttons = root.querySelectorAll('[data-cvp-scroll]');
    var leftBtn = root.querySelector('.cvp-scroll-btn--left');
    var rightBtn = root.querySelector('.cvp-scroll-btn--right');

    function updateBtns() {
      if (!leftBtn || !rightBtn) return;
      var noScroll = container.scrollWidth <= container.clientWidth + 2;
      leftBtn.style.display = noScroll ? 'none' : 'flex';
      rightBtn.style.display = noScroll ? 'none' : 'flex';
      leftBtn.disabled = container.scrollLeft <= 0;
      rightBtn.disabled = container.scrollLeft + container.clientWidth >= container.scrollWidth - 2;
    }

    function centerActive() {
      var active = container.querySelector('.cross-variant-picker__option.is-active');
      if (!active) return;
      var targetLeft = active.offsetLeft - (container.clientWidth / 2) + (active.offsetWidth / 2);
      container.scrollTo({ left: targetLeft, behavior: 'auto' });
    }

    buttons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseInt(btn.getAttribute('data-cvp-scroll'), 10) || 1;
        container.scrollBy({ left: dir * 160, behavior: 'smooth' });
        setTimeout(updateBtns, 300);
      });
    });

    container.addEventListener('scroll', updateBtns, { passive: true });
    window.addEventListener('resize', updateBtns, { passive: true });

    centerActive();
    updateBtns();
  }

  function initAll() {
    document.querySelectorAll('.cross-variant-picker').forEach(function (root) {
      if (root.dataset.cvpInit) return;
      root.dataset.cvpInit = '1';
      initCVP(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
  } catch(e) { console.error(e); }
})();

})();
